import { State } from "../rootReducer";
import { createSelector } from "reselect";
import { AttributesType, IAttributes, IProject, Steps } from "./index";

export const getForm = (state: State) => state.project.form;
export const getCartId = (state: State) => state.project.cartId;
export const getAttributes = (state: State) => state.project.attributes;
export const getZoom = (state: State) => state.project.zoom;
export const getCentred = (state: State) => state.project.centred;
export const getLoading = (state: State) => state.project.loading;
export const getDate = (state: State) => state.project.date;
export const getEditable = (state: State) => state.project.editable;
export const getId = (state: State) => state.project.id;
export const getCart = (state: State) => state.project.cart;
export const getHistory = (state: State) => state.project.history;
export const getLoaded = (state: State) => state.project.loaded;

export const getSelectedAttributes = (state: State) =>
    state.project.selectedAttributes;

export const getCurrentProject = createSelector(
    [getId, getDate, getEditable, getSelectedAttributes],
    (id, date, editable, attr): IProject => {
        return {
            id: id || "",
            date: date || new Date().getTime(),

            count: 1,
            components: attr as IAttributes[],
            editable: editable,
        };
    }
);

export const getAttributesByStep = (step: Steps) =>
    createSelector([getAttributes], (attr) =>
        attr.filter((a) => a.step === step)
    );
